import angular from 'angular';

const controllersModule = angular.module('TLFApp.controllers', []);

function importAll (r) {
  r.keys().forEach(function(key){
    var controller = r(key).default;
    controllersModule.controller(controller.name, controller.fn);
  });
}

importAll(require.context('.', false, /controller.js$/));

export default controllersModule;

